// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PrivacyPolicy_privacyPolicy__UCtY6","pageHeading":"PrivacyPolicy_pageHeading__RSgMo","modifiedOn":"PrivacyPolicy_modifiedOn__0fP1E"};